export default __webpack_public_path__ + "static/setup-5dc4b9a0200cb691677b1bdcfb694802.jpg";